import type { FC, PropsWithChildren } from 'react'
import { Body2, Caption1 } from '@dhl-ui/components'
import { useSearchContext } from '~/search/model/context.js'

export const SearchResultSecondaryText: FC<PropsWithChildren> = ({ children }) => {
  const { isDesktop } = useSearchContext()
  const Typography = isDesktop ? Body2 : Caption1

  return <Typography variant="secondary">{children}</Typography>
}
